module.exports = __webpack_public_path__ + "img/35.5a5a6e74.png";